<template>
	<nav class="navbar" style="z-index: 0;">
		<div class="navbar-container" aria-label="以下为页面导航栏，包括首页，搜索课程，预约志愿者和个人中心四部分，您可以点击任意链接使用相应功能。" tabindex="0">
			<img
				class="logo"
				src="../assets/logo.jpg"
				alt="创善助盲网校"
				tabindex="0"
			>
			<div class="navbar-menu">
				<router-link 
					to="/"
					class="navbar-link"
				>
					首页
				</router-link>

				<router-link 
					to="/search"
					class="navbar-link"
				>
					搜索课程
				</router-link>

				<router-link 
					to="/volunteer"
					class="navbar-link"
				>
					预约志愿者
				</router-link>

				<router-link
					to="/user"
					class="navbar-link"
				>
					个人中心
				</router-link>
			</div>
		</div>
	</nav>
</template>

<style scoped>
.navbar {
	position: fixed;
	top: 0;
	left: 0;
	background-color: transparent;
	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	z-index: 1000;
	width: 40%;
	height: 50px;
}

.navbar-container {
	width: 100%;
	height: 100%;
	margin: 0 auto;
	padding: 1rem;
	display: flex;
}

.logo {
	width: 15%;
	margin-right: 5%;
	height: auto;
}

.navbar-menu {
	display: flex;
	width: 80%;
	justify-content:space-between;
}

.navbar-link {
	text-align: center;
	text-decoration: none;
	color: #666;
	font-weight: 500;
	padding: 0.5rem 0;
	position: relative;
}

.navbar-link::after {
	content: '';
	position: absolute;
	bottom: 0;
	left: 0;
	width: 0;
	height: 2px;
	background-color: #42b983;
	transition: width 0.3s ease;
}

.navbar-link:hover::after {
	width: 100%;
}

.navbar-link.router-link-exact-active {
	color: #42b983;
}

@media (max-width: 500px) {
	.navbar {
		width: 100%;
		height: 90px;
	}

	.navbar-container {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}

	.logo {
		width: auto;
		height: 50px;
		margin-bottom: 10px;
	}

	.navbar-menu{
		width: 100%;
		height: 30px;
	}

	.navbar-link {
		width: fit-content;
		flex-grow: 1;
	}
}
</style>
